import React, { forwardRef } from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { Control } from '@vlabs/uikit';
import { parseISO } from 'date-fns';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import { useCardPageFiltersTranslation } from '../i18n';
import st from './DateFilterPopover.module.sass';
import { useCardPageFilters } from '../useCardPageFilters';

function DateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useCardPageFiltersTranslation();
  const { filters, updateFilters } = useCardPageFilters();

  return (
    <PopoverWithButton
      {...props}
      onClickReset={() => updateFilters({
        create_time__gte: undefined,
        create_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__gte"
          isClearable
          label={t('from') as unknown as string}
          name="create_time__gte"
          onChange={([create_time__gte]: Date[]) => updateFilters({
            create_time__gte: create_time__gte?.toISOString(),
          })}
          onClear={() => updateFilters({ create_time__gte: undefined })}
          options={START_OF_DAY}
          value={filters.create_time__gte ? parseISO(filters.create_time__gte) : ''}
        />
      </div>

      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__lt"
          isClearable
          label={t('to') as unknown as string}
          name="create_time__lt"
          onChange={([create_time__lt]: Date[]) => updateFilters({
            create_time__lt: create_time__lt?.toISOString(),
          })}
          onClear={() => updateFilters({ create_time__lt: undefined })}
          options={END_OF_DAY}
          value={filters.create_time__lt ? parseISO(filters.create_time__lt) : ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const DateFilterPopoverWithRef = forwardRef(DateFilterPopover);
export { DateFilterPopoverWithRef as DateFilterPopover };
